/**
 * 시작하기 FAQ 데이터
 * SEO 최적화 및 사용자 경험을 위한 구조화된 데이터
 */

export const gettingStartedFaq = [
  {
    id: 'getting-started-001',
    category: 'getting-started',
    question: '왓퀴즈가 처음인데, 어떻게 시작하면 좋을까요?',
    answer: `
      <h3>첫 자료 만들기</h3>
      <p>왓퀴즈는 채팅에서 학습지, PPT, 생기부, 채점을 만듭니다.</p>
      <ol>
        <li><strong>/chat</strong>으로 들어가요.</li>
        <li>만들 자료 종류를 골라요.</li>
        <li>과목·단원·원하는 형태를 짧게 적어요.</li>
        <li>예: "중2 일차함수 객관식 10개"</li>
        <li>결과를 읽고, 필요하면 수정해 달라고 해요.</li>
      </ol>

      <h4>참고 자료가 있을 때</h4>
      <ul>
        <li>글만 넣을 때는 <a href="/chat/settings">참고 자료함</a>에 저장해요.</li>
        <li>무료는 텍스트 자료 3개까지예요.</li>
        <li>파일 첨부는 PRO에서만 가능해요.</li>
      </ul>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>로그인이 안 되면 구글 로그인을 다시 해요.</li>
        <li>생성이 멈추면 페이지를 새로고침해요.</li>
        <li>그래도 안 되면 채널톡 또는 angel@plactical.com으로 문의해요.</li>
      </ul>
    `,
    tags: ['시작하기', '첫 사용', '학습지 만들기', '가입', '무료 사용', '왓퀴즈 사용법'],
    relatedFaqs: ['getting-started-002', 'getting-started-003', 'worksheet-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 시작하기 - 첫 학습지 만들기',
    seoDescription: '왓퀴즈 채팅에서 학습지, PPT, 생기부를 만드는 순서. 참고 자료함과 문제가 생겼을 때 확인할 점도 안내합니다.'
  },
  
  {
    id: 'getting-started-002',
    category: 'getting-started',
    question: '구글 로그인이 안전한가요?',
    answer: `
      <h3>구글 로그인</h3>
      <p>왓퀴즈는 구글 계정으로 로그인해요. 만든 자료를 계정에 보관하려면 로그인이 필요해요.</p>

      <h4>보관하는 정보</h4>
      <ul>
        <li>이름과 이메일만 받아요.</li>
        <li>교육 서비스 제공 외 용도로는 쓰지 않아요.</li>
        <li>제3자에게 넘기지 않아요.</li>
      </ul>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>팝업이 막혀 있으면 허용해 주세요.</li>
        <li>시크릿 창에서 다시 시도해 보세요.</li>
        <li>쿠키를 지운 뒤 다시 로그인해 보세요.</li>
        <li>계속 실패하면 채널톡 또는 angel@plactical.com으로 문의해요.</li>
      </ul>
    `,
    tags: ['회원가입', '구글 로그인', '안전성', '개인정보 보호', '계정', '보안'],
    relatedFaqs: ['getting-started-001', 'technical-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 구글 로그인 안내',
    seoDescription: '왓퀴즈 구글 로그인 방식과 보관 정보, 로그인이 안 될 때 확인할 점을 안내합니다.'
  },

  {
    id: 'getting-started-003',
    category: 'getting-started',
    question: '무료로 얼마나 사용할 수 있나요? 유료 구독이 꼭 필요한가요?',
    answer: `
      <h3>무료와 PRO 차이</h3>
      <p>무료로 시작할 수 있어요. 고급 모델과 파일 첨부가 필요하면 PRO를 쓰면 돼요.</p>

      <h4>무료</h4>
      <ul>
        <li>기본 AI 모델로 채팅·학습지·생기부를 만들어요. 채팅 횟수 제한은 없어요.</li>
        <li>생기부는 한 번에 최대 3명(초등 교과는 4명)까지 만들어요.</li>
        <li>참고 자료함에는 텍스트 3개까지 넣어요.</li>
        <li>PPT는 글자형으로 8장까지 만들어 PPTX로 받아요.</li>
        <li>파일 첨부, 엑셀 일괄 처리, 디자인형 PPT·학습지는 없어요.</li>
      </ul>

      <h4>PRO</h4>
      <ul>
        <li>GPT-6.1, Claude Sonnet 5.5, Gemini 3.1 Pro를 쓸 수 있어요.</li>
        <li>생기부를 한 번에 30명, 엑셀로 150명까지 만들어요.</li>
        <li>파일을 첨부하고, 참고 자료함은 500개까지예요.</li>
        <li>디자인형 PPT·학습지를 쓰고, PPT는 40장까지 만들어요.</li>
      </ul>

      <h4>요금</h4>
      <ul>
        <li>1개월 24,000원</li>
        <li>3개월 60,000원 (월 20,000원)</li>
        <li>6개월 110,000원 (월 18,333원)</li>
        <li>12개월 200,000원 (월 16,667원)</li>
      </ul>
      <p>기간이 끝나면 자동 결제되지 않고 무료로 바뀌어요.</p>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>파일 버튼이 잠겨 있으면 PRO가 필요해요.</li>
        <li>결제·환불은 <a href="/pricing">요금제</a>와 마이페이지에서 확인해요.</li>
      </ul>
    `,
    tags: ['무료 사용', '무료 한도', '사용 한도', '유료 구독', 'Pro 구독', '요금', '가격', '비용'],
    relatedFaqs: ['payment-001', 'payment-002', 'features-001'],
    lastUpdated: '2026-10-15',
    seoTitle: '왓퀴즈 무료와 PRO 비교',
    seoDescription: '무료로 쓸 수 있는 범위(채팅 무제한, 생기부 3명)와 PRO 모델·파일 첨부·요금(월 16,667원부터)을 비교합니다.'
  },

  {
    id: 'getting-started-004',
    category: 'getting-started',
    question: '스마트폰에서도 사용할 수 있나요? 앱이 있나요?',
    answer: `
      <h3>모바일 웹</h3>
      <p>별도 앱은 없어요. 브라우저에서 whatquiz.co.kr을 열면 돼요.</p>

      <h4>홈 화면에 두는 방법</h4>
      <ol>
        <li>Safari 또는 Chrome에서 사이트를 열어요.</li>
        <li>공유 메뉴에서 "홈 화면에 추가"를 눌러요.</li>
        <li>아이콘을 눌러 바로 들어가요.</li>
      </ol>

      <h4>잘 안 될 때</h4>
      <ul>
        <li>화면이 깨지면 Chrome 최신 버전을 써 보세요.</li>
        <li>로그인이 막히면 팝업과 쿠키를 허용해요.</li>
        <li>긴 편집은 컴퓨터를 쓰는 편이 편해요.</li>
      </ul>
    `,
    tags: ['모바일', '스마트폰', '앱', '모바일 사용법', '터치', '홈화면 추가'],
    relatedFaqs: ['technical-001', 'worksheet-003', 'getting-started-001'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈 모바일 사용법',
    seoDescription: '왓퀴즈는 앱 없이 모바일 브라우저에서 이용합니다. 홈 화면 추가와 문제 해결을 안내합니다.'
  },

  {
    id: 'getting-started-005',
    category: 'getting-started',
    question: '다른 AI 문제 생성 서비스와 뭐가 다른가요?',
    answer: `
      <h3>교사 업무에 맞춘 기능</h3>
      <p>왓퀴즈는 학습지, 생기부, 채점, PPT, 한글 양식을 한 채팅에서 다뤄요.</p>
      <ul>
        <li>학습지: 객관식·서술형·루브릭을 채팅으로 만들어요.</li>
        <li>생기부: 관찰 내용을 바탕으로 초안을 적어요.</li>
        <li>채점: 기준표를 올리면 답안을 채점해요. 파일은 PRO예요.</li>
        <li>한글: 양식을 올리면 내용을 채워 줘요. 파일은 PRO예요.</li>
      </ul>
      <p>PRO에서는 GPT-6.1, Claude Sonnet 5.5, Gemini 3.1 Pro를 골라 쓸 수 있어요.</p>

      <h4>잘 안 맞을 때</h4>
      <ul>
        <li>결과가 어색하면 학년·단원을 더 구체적으로 적어요.</li>
        <li>학교 양식이 있으면 참고 자료함이나 파일로 붙여요.</li>
        <li>생기부 결과는 초안이니 나이스에 그대로 넣지 마세요.</li>
      </ul>
    `,
    tags: ['차별점', '특징', '비교', '교육과정', '교사 전용', '왓퀴즈 장점'],
    relatedFaqs: ['getting-started-001', 'worksheet-001', 'payment-003'],
    lastUpdated: '2026-09-09',
    seoTitle: '왓퀴즈와 다른 AI 서비스 차이',
    seoDescription: '학습지, 생기부, 채점, PPT, 한글을 한곳에서 다루는 왓퀴즈와 일반 AI의 차이를 안내합니다.'
  },
  {
    id: 'getting-started-006',
    category: 'getting-started',
    question: '학생부 상업적 이용 제한 법 시행 후에도 생기부 기능을 사용해도 되나요?',
    answer: `
      <h3>교사의 통상적인 업무 보조 이용은 주요 위반 사례와 다릅니다</h3>
      <p>2026년 7월 29일부터 시행되는 개정 「초·중등교육법」은 학교생활기록을 취득해 <strong>영업 목적으로 거래하거나 이용하는 행위</strong>를 제한합니다.</p>
      <p>교육부가 안내한 주요 위반 사례는 학생부를 구매해 입시 상담에 사용하거나, 수집한 학생부로 유료 강의·자료·AI 학습 데이터·유료 추천 서비스를 만드는 경우입니다.</p>
      <p>왓퀴즈는 교사가 직접 관찰·평가한 자료로 학생부 초안을 작성하고 기재요령을 점검하도록 돕는 도구이며, 학생·학부모 대상 입시 상담이나 학생부 거래 서비스가 아닙니다.</p>

      <h3>왓퀴즈가 지키는 보호 조치</h3>
      <ul>
        <li><strong>원본 파일 미보관:</strong> 검사에 올린 파일 자체는 별도 파일로 저장하지 않습니다.</li>
        <li><strong>개인정보 자동 보호:</strong> 연락처 같은 개인정보는 AI 요청 전에 자동으로 가립니다.</li>
        <li><strong>목적 외 이용 금지:</strong> 검사 자료를 입시 상담, 판매, 광고, AI 모델 학습에 이용하지 않습니다.</li>
        <li><strong>매매·영업 제공 없음:</strong> 학생부를 판매하거나 제3자의 독자적 영업 목적으로 제공한 적이 없고, 앞으로도 그럴 계획이 없습니다.</li>
      </ul>

      <div class="tip-box">
        <p><strong>교사 확인 사항:</strong> 검사기에는 최종 확정본·공식 발급본이 아닌 작성 중인 초안만 이용하고, AI 결과물을 나이스에 그대로 입력하지 말아주세요.</p>
      </div>
      <p><a href="/help/notice/saenggibu-commercial-use-law-2026"><strong>법 개정 내용과 왓퀴즈 대응 전체 안내 보기</strong></a></p>
    `,
    tags: ['생기부', '학교생활기록부', '상업적 이용 제한', '초중등교육법', '개인정보', '원본 파일 미보관'],
    relatedFaqs: ['getting-started-002', 'getting-started-005'],
    lastUpdated: '2026-07-16',
    seoTitle: '학생부 상업적 이용 제한 법과 왓퀴즈 생기부 기능 안내',
    seoDescription: '2026년 7월 29일 시행 학생부 상업적 이용 제한 법의 적용 범위와 왓퀴즈의 원본 파일 미보관, 개인정보 보호 정책을 안내합니다.'
  }
];

// SEO와 관련 FAQ를 위한 유틸리티 함수들
export const getGettingStartedFaqById = (id) => {
  return gettingStartedFaq.find(faq => faq.id === id);
};

export const searchGettingStartedFaq = (query) => {
  const lowerQuery = query.toLowerCase();
  return gettingStartedFaq.filter(faq => 
    faq.question.toLowerCase().includes(lowerQuery) ||
    faq.answer.toLowerCase().includes(lowerQuery) ||
    faq.tags.some(tag => tag.toLowerCase().includes(lowerQuery))
  );
};

export const getRelatedFaqs = (currentFaqId) => {
  const currentFaq = getGettingStartedFaqById(currentFaqId);
  if (!currentFaq) return [];
  
  return currentFaq.relatedFaqs
    .map(id => getGettingStartedFaqById(id))
    .filter(faq => faq !== undefined);
};
